import { LIVE_PULSE_LIMIT, LIVE_WINDOW } from '@/function/traffic/traffic.live.constants';
import trafficRequestsMerge from '@/function/traffic/traffic.requests.merge';
import { trafficApi } from '@/store/api/traffic/traffic.api';
import { trafficLiveApi } from '@/store/api/traffic/traffic.live.api';
import type { TypeAppDispatch } from '@/store/store';
import type { TypeTrafficLive, TypeTrafficRequestsBatch } from '@/types/traffic/types.traffic.live';

export const writeTrafficRequests = (dispatch: TypeAppDispatch, batch: TypeTrafficRequestsBatch): void => {
    if (!batch || !Array.isArray(batch.requests)) return;

    dispatch(trafficLiveApi.util.updateQueryData('readTrafficRequests', undefined, (draft) => {
        draft.requests = trafficRequestsMerge(draft.requests, batch.requests, LIVE_WINDOW);
        draft.masked = batch.masked !== false;
        if (batch.gap === true) draft.skipped += 1;
    }));
};

export const writeTrafficPulse = (dispatch: TypeAppDispatch, live: TypeTrafficLive): void => {
    if (!live || typeof live !== 'object' || !Array.isArray(live.points)) return;

    dispatch(trafficApi.util.updateQueryData('readTrafficLive', LIVE_PULSE_LIMIT, () => live));
};
